import { useSortable } from '@dnd-kit/sortable';
import type { DragData, DragPath } from 'src/types';

export const useDraggableBlock = (id: string, type: string, path: DragPath) =>
  useSortable({
    id,
    data: { type, id, path } satisfies DragData,
  });
